export default [
    'getliveappallinhome',
    'practicelogin',
    'verifyphonenumber',
    'getverifycode',
    'registeredusers',
    'numberuserphoneauthentication', //���ŵ�¼
    'authenticate/retrievepassword', //�һ�����
    'getbindingexamtagpositionlist',
    'addexamregist',
    'getsystemnoticelisthome', //公告、
    'user/gettoken',// 获取用户信息
    'GetVerifyCode',
    'GetExperienceToken',
    'RetrievePassword'
];


// WEBPACK FOOTER //
// ./src/constants/apiPermission.js